var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { AonDialog } from '../../components/core/AonDialog';
import { UuiSpinner } from '@aonunited/react';
import { getPublicationDetails } from '../../api/publicationDetails';
import { AonButton } from '../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../components/core/AonButton/consts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useErrorStore } from '../../store';
export function MarketNewsDailog(props) {
    var _this = this;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(null), htmlInput = _b[0], setHtmlInput = _b[1];
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        setIsLoading(true);
                        if (!props.publicationId) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPublicationDetails({ PublicationTypeIds: props.publicationId })];
                    case 1:
                        response = _a.sent();
                        if (response.data) {
                            setHtmlInput(response.data);
                        }
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var onClickPrint = function () {
        var printDoc = window.open("", "_blank");
        if (printDoc) {
            printDoc.document.open();
            printDoc.document.write("".concat(htmlInput));
            printDoc.document.close();
            printDoc.focus();
            printDoc.print();
            printDoc.close();
        }
    };
    useEffect(function () {
        var html = document.getElementById("__publicationTextBody__");
        if (html && htmlInput) {
            html.innerHTML = htmlInput;
        }
    }, [htmlInput]);
    var Footer = function () {
        return React.createElement("div", null,
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: onClickPrint }, "Print"),
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.PROMINENT, onClick: props.onClickClose }, "Close"));
    };
    var Body = function () {
        return React.createElement("div", null,
            isLoading && React.createElement(UuiSpinner, { variant: 'small' }),
            React.createElement("div", { id: "__publicationTextBody__" }));
    };
    return (React.createElement(AonDialog, { extraClass: "aon-dialog-market-news", dismissOnEsc: false, dismissOnOverlay: false, opened: props.showDialog, enableBackgroundScroll: false, header: React.createElement("div", null,
            React.createElement(FontAwesomeIcon, { style: { position: 'absolute', right: "15px" }, className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(Body, null), footer: React.createElement(Footer, null) }));
}
